import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { TrainingDetailHeroSection } from 'styles/training-detail';
import trainingDateFormat from 'utils/trainingDateFormat';
import lineBreak from 'utils/lineBreak';

const TrainingDetailHero = ({ training }) => (
  <TrainingDetailHeroSection>
    <div className="container">
      <div className="discount">
        {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="39"
              height="38"
              viewBox="0 0 39 38"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  fill="#FF4552"
                  d="M19.5 29.306l-4.667 8.142-.249-9.322-8.015 5.096 4.226-8.367-9.528.882L9 20.242.142 16.71l9.468-1.365-6.158-7.138 9.034 3.079-2.048-9.11 6.531 6.817L19.5 0l2.531 8.993 6.531-6.817-2.048 9.11 9.034-3.079-6.158 7.138 9.468 1.365L30 20.242l7.733 5.495-9.528-.882 4.226 8.367-8.015-5.096-.249 9.322z"
                />
                <text
                  fill="#FFF"
                  fontFamily="Proxima Nova"
                  fontSize="9"
                  fontWeight="bold"
                  letterSpacing=".033"
                >
                  <tspan x="12" y="21">
                    10%
                  </tspan>
                </text>
              </g>
            </svg> */}
        <span
          dangerouslySetInnerHTML={{
            __html: lineBreak(training.courseStatus),
          }}
        />
      </div>
      <h1>
        <span>{training.certificationName}</span>
        {/* {console.log(training)} */}
        {training.trainingId.startsWith('PMP')?
        <a href="https://www.pmi.org/certifications/project-management-pmp" target="_blank"> 
         <img
          src={training.Badge}
          alt="badge"
          style={
            training && training.trainingId.startsWith('ATC')
              ? {
                  height: '100%',
                  width: '82px',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginLeft: 15,
                }
              : {
                  height: 82,
                  width: 82,
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginLeft: 15,
                }
          }
        />
        </a>:<img
          src={training.Badge}
          alt="badge"
          style={
            training && training.trainingId.startsWith('ATC')
              ? {
                  height: '100%',
                  width: '82px',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginLeft: 15,
                }
              : {
                  height: 82,
                  width: 82,
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginLeft: 15,
                }
          }
        />
        }
      </h1>
      <div className="d-flex flex-wrap">
        <div>
          <span className="title">Date</span>
          <span className="subtitle">{trainingDateFormat(training)}</span>
          <span className="title">
            {training.trainingId.startsWith('AC') ? '(Weekends Only)' : ''}
          </span>
        </div>
        <div>
          <span className="title">Venue</span>
          <span className="subtitle">{training.venueAddress}</span>
        </div>
        <div>
          <span className="title">Trainer</span>
          <img
            src={training.pictureLink}
            alt={training.fullName}
            style={{
              height: 77,
              width: 77,
              display: 'inline-block',
              verticalAlign: 'middle',
              borderRadius: '50%',
            }}
          />
          <span
            className="subtitle"
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '50%',
              marginLeft: 15,
            }}
          >
            {training.fullName}
          </span>
        </div>
        {!training.enrollmentClosed ? (
          <>
            <div className="right">
              <Link
                to={`/checkout/${training.trainingId}`}
                className="pink-btn"
              >
                <span className="white">Register Now</span>
              </Link>
            </div>
          </>
        ) : (
          <>
            <div>
              <div
                style={{
                  height: 46,
                  width: 166,
                  marginLeft: 25,
                  marginTop: 10,
                }}
                className="fully-booked"
              >
                <label>Fully Booked</label>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  </TrainingDetailHeroSection>
);

TrainingDetailHero.propTypes = {
  training: PropTypes.object,
};

export default TrainingDetailHero;
